export type DashboardLayoutKey =
  | 'HERO_FOUR'
  | 'GRID_4'
  | 'GRID_6'
  | 'GRID_8'
  | 'LIST_FOCUS'
  | 'HERO_LIST';

export interface DashboardSlotDef {
  colSpan: number;
  minHeight: number;
}

export interface DashboardLayoutDef {
  key: DashboardLayoutKey;
  label: string;
  description: string;
  slots: DashboardSlotDef[];
}

export const DASHBOARD_LAYOUTS: DashboardLayoutDef[] = [
  {
    key: 'HERO_FOUR',
    label: 'Hero + Four',
    description: 'One big hero chart, a tall side panel, and four smaller charts below.',
    slots: [
      { colSpan: 9, minHeight: 360 },
      { colSpan: 3, minHeight: 360 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
    ],
  },
  {
    key: 'GRID_4',
    label: 'Grid 2x2',
    description: 'Four equal large charts.',
    slots: [
      { colSpan: 6, minHeight: 260 },
      { colSpan: 6, minHeight: 260 },
      { colSpan: 6, minHeight: 260 },
      { colSpan: 6, minHeight: 260 },
    ],
  },
  {
    key: 'GRID_6',
    label: 'Grid 2x3',
    description: 'Six equal charts in two rows.',
    slots: [
      { colSpan: 4, minHeight: 240 },
      { colSpan: 4, minHeight: 240 },
      { colSpan: 4, minHeight: 240 },
      { colSpan: 4, minHeight: 240 },
      { colSpan: 4, minHeight: 240 },
      { colSpan: 4, minHeight: 240 },
    ],
  },
  {
    key: 'GRID_8',
    label: 'Grid 2x4',
    description: 'Eight compact charts in two rows.',
    slots: [
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
      { colSpan: 3, minHeight: 220 },
    ],
  },
  {
    key: 'LIST_FOCUS',
    label: 'List + Charts',
    description: 'A tall full-height list (e.g. tasks) beside a 2x2 chart grid.',
    slots: [
      { colSpan: 4, minHeight: 520 },
      { colSpan: 4, minHeight: 250 },
      { colSpan: 4, minHeight: 250 },
      { colSpan: 4, minHeight: 250 },
      { colSpan: 4, minHeight: 250 },
    ],
  },
  {
    key: 'HERO_LIST',
    label: 'Hero + List',
    description: 'A hero chart, a tall list panel, and two charts below.',
    slots: [
      { colSpan: 9, minHeight: 340 },
      { colSpan: 3, minHeight: 340 },
      { colSpan: 6, minHeight: 240 },
      { colSpan: 6, minHeight: 240 },
    ],
  },
];

export const getLayoutDef = (key: DashboardLayoutKey): DashboardLayoutDef =>
  DASHBOARD_LAYOUTS.find((l) => l.key === key) ?? DASHBOARD_LAYOUTS[0];
